export default {
    token: "",
    user: {},
    locales: ['en', 'zh'],
    locale: 'en',
};